import { NatRounded } from "@mui/icons-material";
import React from "react";

const WorkoutPlan = ({ plan = {} }) => {
  // plan = JSON.parse(plan)
  if (typeof plan === 'string') {
    try {
      plan = JSON.parse(plan);
    } catch (e) {
      console.error("Failed to parse plan JSON:", e);
      plan = {};
    }
  }

  // Normalize structure for consistency
  const normalizedPlan = {
    Summary: plan.Summary || (plan.workoutPlan && { Overview: plan.workoutPlan.overview }),
    // WorkoutPlan: plan.WorkoutPlan || (plan.workoutPlan && { SessionStructure: plan.workoutPlan.sessions }),
    WorkoutPlan: plan.WorkoutPlan || (plan.workoutPlan && { SessionStructure: plan.workoutPlan.sessionStructure }),

    WeeklyPlanSummary: plan.WeeklyPlanSummary || (plan.workoutPlan && plan.workoutPlan.weeklyPlanSummary),
    Notes: plan.Notes || (plan.workoutPlan && [plan.workoutPlan.notes]),
  };

  console.log("Normalized Plan:", normalizedPlan);

  console.log("Plan prop:", plan);
  console.log("Summary:", normalizedPlan?.Summary);
  console.log("SessionStructure:", normalizedPlan?.WorkoutPlan?.SessionStructure);
  console.log("WeeklyPlanSummary:", normalizedPlan?.WeeklyPlanSummary);
  console.log("Notes:", normalizedPlan?.Notes);


  
  const handleSaveWorkout = async () => {
    try {
      // Prepare workout data for the API
      const workoutData = {
        name: "Personalized Workout Plan", 
        description: normalizedPlan.Summary?.Overview || "AI Customized Workplan",
        workoutData: normalizedPlan.WorkoutPlan, 
      };
  
      // Retrieve the token (adjust this based on how your app manages tokens)
      const token = localStorage.getItem('authToken'); 
  
      // Call the saveUserWorkout API
      const response = await fetch('/api/v1/save-workout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, 
        },
        body: JSON.stringify(workoutData),
      });
  
      // Process the response
      if (response.ok) {
        const result = await response.json();
        alert('Workout saved successfully!');
        console.log('Saved workout:', result);
      } else {
        const error = await response.json();
        console.error('Error saving workout:', error);
        alert(`Failed to save workout: ${error.error}`);
      }
    } catch (err) {
      console.error('Error saving workout:', err);
      alert('An unexpected error occurred while saving the workout.');
    }
  };

  const handlePrintView = () => {
    try {
      const workoutPlanContent = document.getElementById("workout-result").innerHTML;
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html lang="en">
          <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Print Workout Plan</title>
              <style>
                  body {
                      font-family: Arial, sans-serif;
                      margin: 20px;
                      line-height: 1.6;
                  }
              </style>
          </head>
          <body>
              ${workoutPlanContent}
          </body>
          </html>
        `);
        newWindow.document.close();
      }
    } catch (error) {
      console.error("Error generating print view:", error);
    }
  };

  return (
    // <div className="main-content">
      <div className="section" id="workout-result">
        <div className="header">
          <h1>Your Personalized Workout Plan</h1>
        </div>
        <hr className="custom-line" />
        
        {/* Debug Data */}
        {/* <div>
          <h2>Debug Data</h2>
          <pre>{JSON.stringify(plan, null, 2)}</pre>
        </div> */}
        {/* Summary */}
        <div className="section">
        {normalizedPlan.Summary && (
            <section>
              <h2>Workout Plan Overview</h2>
              <p>{normalizedPlan.Summary.Overview || 'No overview available'}</p>
            </section>
          )}

<div>
  <h2>Weekly Schedule</h2>
  {(normalizedPlan?.WorkoutPlan?.SessionStructure?.length ?? 0) > 0 ? (
    normalizedPlan.WorkoutPlan.SessionStructure.map((session, index) => {
      const sessionTitle = session.Session || session.session || `Session ${index + 1}`;
      const focus = session.Focus || session.focus || "No focus provided";
      const frequencyAndSets = session.FrequencyAndSets || session.frequencyAndSets;

      const exercises = session.Exercises || session.exercises;
      const options = session.Options || session.options;

      return (
        <section key={index}>
          <h3>{sessionTitle}: {focus}</h3>
          {frequencyAndSets && <p>{frequencyAndSets}</p>}
          <ul>
            {Array.isArray(exercises) ? (
              exercises.map((exercise, idx) => {
                const name = exercise.Name || exercise.name || "Unnamed Exercise";
                const target = exercise.Target || exercise.target;
                const reps = exercise.Reps || exercise.reps;
                const duration = exercise.Duration || exercise.duration;
                const progression = exercise.Progression || exercise.progression;

                return (
                  <li key={idx}>
                    <strong>{name}</strong>
                    {target && ` Target: ${target}`}
                    {reps && ` Reps: ${reps}`}
                    {duration && ` Duration: ${duration}`}
                    {progression && ` Progression: ${progression}`}
                  </li>
                );
              })
            ) : (
              <li>
                {typeof exercises === "string"
                  ? exercises
                  : "Limit exercises and focus on recovery"}
              </li>
            )}
            {Array.isArray(options) && options.length > 0 && (
              <li>Options: {options.join(", ")}</li>
            )}
          </ul>
        </section>
      );
    })
  ) : (
    <p>No workout sessions available.</p>
  )}
</div>
          {/* Weekly Schedule */}
          {/* <div>
            <h2>Weekly Schedule</h2>
            {normalizedPlan?.WorkoutPlan?.SessionStructure?.length > 0 ? (
              normalizedPlan.WorkoutPlan.SessionStructure.map((session, index) => (
                <section key={index}>
                  <h3>
                    Session {session.sessionNumber}: {session.focus || "No focus provided"}
                  </h3>
                  <p>{session.frequencyAndSets || "No frequency or sets info available"}</p>
                  <ul>
                    {Array.isArray(session.exercises) ? (
                      session.exercises.map((exercise, idx) => (
                        <li key={idx}>
                          <strong>{exercise.name || exercise.Name}</strong>
                          {exercise.target && ` Target: ${exercise.target}`}
                          {exercise.reps && ` Reps: ${exercise.reps}`}
                          {exercise.duration && ` Duration: ${exercise.duration}`}
                          {exercise.progression && ` Progression: ${exercise.progression}`}
                        </li>
                      ))
                    ) : (
                      <li>{typeof session.exercises === "string" ? session.exercises : "Limit exercises and focus on recovery"}</li>
                    )}
                    {session.options?.length > 0 && (
                      <li>Options: {session.options.join(", ")}</li>
                    )}
                  </ul>
                </section>
              ))
            ) : (
              <p>No workout sessions available.</p>
            )}
          </div> */}

          {/* Weekly Plan Summary */}
          {normalizedPlan?.WeeklyPlanSummary?.length > 0 && (
            <div>
              <h2>Weekly Plan Summary</h2>
              <ul>
                {normalizedPlan.WeeklyPlanSummary.map((summary, index) => (
                  <li key={index}>{summary}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Notes */}
          {normalizedPlan?.Notes?.length > 0 && (
            <div>
              <h2>Notes</h2>
              <ul>
              {normalizedPlan.Notes.map((note, index) => (
                <li key={index}>{note}</li>
              ))}
              </ul>
            </div>
          )}

          {/* Print View Button */}
          <button
            id="print-view-button"
            className="button-style"
            onClick={handlePrintView}
          >
            Print View
          </button>
          <button
            id="save-workout-button"
            className="button-style"
            onClick={handleSaveWorkout}
          >
            Save Workout
          </button>
        </div>
      {/* </div> */}
    </div>
  );
};

export default WorkoutPlan;